"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewDerivateBase = void 0;
const field_1 = require("../../model/field");
const view_filter_derivate_1 = require("./slice/view_filter_derivate");
const selectors_1 = require("../../exports/store/selectors");
class ViewDerivateBase {
    constructor(state, datasheetId) {
        this.state = state;
        this.datasheetId = datasheetId;
        this.viewFilterDerivate = new view_filter_derivate_1.ViewFilterDerivate(state, datasheetId);
    }
    getSortRowsByGroup(view, rows) {
        var _a, _b;
        const state = this.state;
        const snapshot = (_a = this.state.datasheetMap[this.datasheetId]) === null || _a === void 0 ? void 0 : _a.datasheet.snapshot;
        if (!view || !snapshot) {
            return [];
        }
        const fieldMap = snapshot.meta.fieldMap;
        if (!view.groupInfo) {
            return rows;
        }
        const fieldPermissionMap = (_b = this.state.datasheetMap[this.datasheetId]) === null || _b === void 0 ? void 0 : _b.fieldPermissionMap;
        const groups = (0, selectors_1.getGroupFields)(view, snapshot.meta.fieldMap, fieldPermissionMap);
        if (!groups.length) {
            return rows;
        }
        const descOrders = view.groupInfo.reduce((acc, gp) => {
            if (fieldMap[gp.fieldId]) {
                acc.push(gp.desc);
            }
            return acc;
        }, []);
        const fieldInstanceMap = {};
        const cacheSortRes = {};
        // rows sorted by group
        return rows.sort((row1, row2) => {
            return groups.reduce((prev, field, index) => {
                if (prev !== 0) {
                    return prev;
                }
                let fieldInstance = fieldInstanceMap[field.id];
                if (!fieldInstance) {
                    fieldInstance = field_1.Field.bindContext(field, state);
                    fieldInstanceMap[field.id] = fieldInstance;
                }
                const cv1 = (0, selectors_1.getCellValue)(state, snapshot, row1.recordId, field.id);
                const cv2 = (0, selectors_1.getCellValue)(state, snapshot, row2.recordId, field.id);
                const key = `${cv1}${cv2}`;
                let res = 0;
                if (key in cacheSortRes) {
                    res = cacheSortRes[key];
                }
                else {
                    res = fieldInstance.compare(cv1, cv2);
                    typeof cv1 !== 'object' && typeof cv2 !== 'object' && (cacheSortRes[key] = res);
                }
                const sign = descOrders[index] ? -1 : 1;
                return res * sign;
            }, 0) || 1;
        });
    }
    getSortRows(view, rows) {
        var _a, _b, _c, _d;
        if (!(view === null || view === void 0 ? void 0 : view.sortInfo) || !view.sortInfo.keepSort) {
            return rows;
        }
        const snapshot = (_a = this.state.datasheetMap[this.datasheetId]) === null || _a === void 0 ? void 0 : _a.datasheet.snapshot;
        if (!snapshot) {
            return [];
        }
        const mirrorId = this.state.pageParams.mirrorId;
        const mirrorSortInfo = (_d = (_c = (_b = this.state.mirrorMap[mirrorId]) === null || _b === void 0 ? void 0 : _b.mirror) === null || _c === void 0 ? void 0 : _c.temporaryView) === null || _d === void 0 ? void 0 : _d.sortInfo;
        if (mirrorSortInfo) //解决导出exce临时排序丢掉的问题
            return (0, selectors_1.sortRowsBySortInfo)(this.state, rows, mirrorSortInfo.rules, snapshot);
        else
            return (0, selectors_1.sortRowsBySortInfo)(this.state, rows, view.sortInfo.rules, snapshot);
    }
    getSearchRows(rows, view) {
        var _a;
        const searchKeyword = (0, selectors_1.getSearchKeyword)(this.state);
        if (!searchKeyword) {
            return { visibleRows: rows };
        }
        const snapshot = (_a = this.state.datasheetMap[this.datasheetId]) === null || _a === void 0 ? void 0 : _a.datasheet.snapshot;
        if (!snapshot) {
            return { visibleRows: rows };
        }
        const lowerCaseSearchKeyword = searchKeyword.toLowerCase();
        const searchResults = [];
        const visibleColumns = !(view === null || view === void 0 ? void 0 : view.columns) ? [] : view.columns.filter(item => !item.hidden).map(item => item.fieldId);
        const visibleRows = rows.filter(row => {
            const { recordId } = row;
            let isRecordDataMatchKeyword = false;
            visibleColumns.forEach(fieldId => {
                const cellValue = (0, selectors_1.getStringifyCellValue)(this.state, snapshot, recordId, fieldId);
                if (cellValue && cellValue.toLowerCase().includes(lowerCaseSearchKeyword)) {
                    searchResults.push([recordId, fieldId]);
                    isRecordDataMatchKeyword = true;
                }
            });
            return isRecordDataMatchKeyword;
        });
        return { visibleRows, searchResults };
    }
    /**
     * An array in order after filtering and sorting by view properties.
     * @param view view properties
     */
    getRowsAfterViewQuery(view, affectRecords, affectFields) {
        if (!view) {
            return [];
        }
        if (affectRecords && affectFields && affectFields.length > 0) {
        }
        // where exact match by field
        const filteredRows = this.viewFilterDerivate.getFilteredRows(view).filter(item => !item.hidden);
        // order by
        const sortedRows = this.getSortRows(view, filteredRows);
        // group by
        return this.getSortRowsByGroup(view, sortedRows);
    }
    /**
     * View Calculation of Derived Data
     *
     * For views that do not require custom view-derived data,
     * you can call this method directly to return it, otherwise you need to override it.
     */
    getViewDerivation(view, affectRecords, affectFields) {
        view = view || (0, selectors_1.getCurrentView)(this.state);
        if (!view || !view.rows) {
            throw new Error("View not loaded, can't get view data");
        }
        const rowsInView = this.getRowsAfterViewQuery(view, affectRecords, affectFields);
        return Object.assign({ rowsWithoutSearch: rowsInView }, this.getViewDerivationWithSearch(view, rowsInView));
    }
    /**
     * Get computationally derived data containing search results.
     *
     * Used to do calculations when searching for updates.
     */
    getViewDerivationWithSearch(view, rowsWithoutSearch) {
        if (!view || !view.rows) {
            throw new Error("View not loaded, can't get view data");
        }
        const { visibleRows, searchResults } = this.getSearchRows(rowsWithoutSearch, view);
        const visibleRowsIndexMap = new Map(visibleRows.map((item, index) => [item.recordId, index]));
        return {
            // Raw rows of data, grouped without any filtering sorting.
            rowsIndexMap: new Map(view.rows.map((item, index) => [item.recordId, index])),
            // Excluding pre-sorted row data, including filtered sorted grouped search.
            pureVisibleRows: visibleRows,
            // Map of the row-order data after view property calculation
            pureVisibleRowsIndexMap: visibleRowsIndexMap,
            // Visible row data, including filtering sorting grouping search [pre-sorting],
            // Kanban view does not have pre-sorting, so it is the same as pureVisibleRows.
            visibleRows,
            // A map with recordId as key and order as value.
            visibleRowsIndexMap: visibleRowsIndexMap,
            searchResults
        };
    }
}
exports.ViewDerivateBase = ViewDerivateBase;
//# sourceMappingURL=view_derivate_base.js.map